import { Eyebrow, Reveal } from "./Reveal";

const STEPS = [
  { n: "01", title: "Discover", desc: "Understand the business problem, users and goals." },
  { n: "02", title: "Analyse", desc: "Study requirements, workflows, stakeholders and business rules." },
  { n: "03", title: "Define", desc: "Create the product scope, requirements and user journeys." },
  { n: "04", title: "Structure", desc: "Prepare user stories, acceptance criteria and product backlog." },
  { n: "05", title: "Build", desc: "Coordinate or support development using development-ready specifications." },
  { n: "06", title: "Validate", desc: "Support UAT and validate the delivered product against requirements." },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal>
          <Eyebrow>How I Work</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-display text-4xl font-semibold leading-[1.15] tracking-tight md:text-5xl">
            From idea to product
          </h2>
        </Reveal>

        <div className="relative mt-16">
          <div
            className="absolute left-0 right-0 top-[7px] hidden border-t border-dashed border-navy/25 lg:block"
            aria-hidden="true"
          />
          <ol className="grid grid-cols-1 gap-10 border-l border-dashed border-navy/25 pl-8 sm:grid-cols-2 lg:grid-cols-6 lg:border-0 lg:pl-0">
            {STEPS.map((step, i) => (
              <Reveal key={step.n} delay={i * 0.07}>
                <li data-testid={`process-step-${i}`} className="relative">
                  <span
                    className="absolute -left-[41px] top-1.5 block h-3.5 w-3.5 rounded-full border-2 border-rust bg-cream lg:relative lg:-left-0 lg:top-0 lg:mb-8"
                    aria-hidden="true"
                  />
                  <p className="font-display text-3xl text-rust/80">{step.n}</p>
                  <h3 className="mt-3 text-base font-semibold tracking-tight">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-navy/65">
                    {step.desc}
                  </p>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
